<div class="flex flex-col justify-center items-center py-8 gap-2">
  <img src="/icons/exclamation-blue.svg"/>
  <div class="text-gray-900 flex flex-col justify-center items-center gap-2">
    <div class=" font-bold text-lg">{{getText()[target()].title}}</div>
    <div>{{getText()[target()].content}}</div>
  </div>
</div>